import { useReduxState } from "../../explorer/redux/hooks";
import { defaultContext } from "../../site/configuration/defaultSettings";
import { reduxStoreConfig } from "../../site/configuration/reduxStoreConfig";
import { NavigationState } from "../types";
import { AppContext, AppInfo } from "../types/System/AppInfo";

const useAppContext: () => {
  currentContext: string;
  appContexts: AppContext[];
} = () => {
  const [navigationState] = useReduxState<NavigationState>(
    reduxStoreConfig.systemNavigationState
  );
  const [appInfo] = useReduxState<AppInfo>(reduxStoreConfig.systemAppInfo);
  const currentContext = navigationState.context ?? defaultContext;
  return {
    currentContext,
    appContexts: appInfo.appContexts ?? []
  };
};
export default useAppContext;
